module.exports = __webpack_public_path__ + "media/images/emblems/Obermumpf-blason-9c00ec478aa199cb916f6467c78daaa1.png";